export const frequencyOptions = [
  { label: "Yearly", value: "ANNUAL" },
  { label: "Monthly", value: "MONTHLY" },
  { label: "Adhoc", value: "AD_HOC" },
];

export const billingDateOptions = [
  {
    label: "1st of Month",
    value: "MONTH_FIRST",
  },
  {
    label: "2nd of Month",
    value: "MONTH_SECOND",
  },
  {
    label: "3rd of Month",
    value: "MONTH_THREE",
  },
  {
    label: "4th of Month",
    value: "MONTH_FOUR",
  },
  {
    label: "5th of Month",
    value: "MONTH_FIVE",
  },
  {
    label: "Last Day of Previous Month",
    value: "LAST_DAY_OF_PREVIOUS_MONTH",
  },
];

export const transactionTypeOptions = [
  {
    label: "Yearly HOA Fee",
    value: "ANNUAL_HOA_FEE",
  },
  {
    label: "Monthly HOA Fee",
    value: "MONTHLY_HOA_FEE",
  },
  {
    label: "Adhoc HOA Fee",
    value: "ADHOC_HOA_FEE",
  },
];

export const transactionTypeValues = {
  ANNUAL_HOA_FEE: "Annual",
  MONTHLY_HOA_FEE: "Monthly",
  ADHOC_HOA_FEE: "Adhoc",
};

export const frequencyTypeOption = {
  ANNUAL_HOA_FEE: "ANNUAL",
  MONTHLY_HOA_FEE: "MONTHLY",
  ADHOC_HOA_FEE: "AD_HOC",
};

export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";
export const BILLING_RUN_DATE = "billingRunDate";
export const JOB_RUN_STATUS = "status";

export const searchType = [
  { label: "Billing Category", value: "billingCategoryIds" },
  { label: "Transaction Type", value: "transactionType" },
  { label: "Frequency", value: "frequency" },
];

export const jobStatus = [
  { label: "All", value: "all" },
  { label: "Pending", value: "PENDING" },
  { label: "Completed", value: "COMPLETED" },
];
